/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { IconButton } from 'components/Buttons/IconButton';
import { Typography } from 'components/Typography';

export const FiltersOuterWrapper = styled(Box)`
  min-width: 210px;
`;

export const CloseButton = styled(IconButton)`
  ${({ theme }) => (theme as any).breakpoints.up('lg')} {
    display: none;
  }
`;

export const Header = styled(Typography)`
  color: ${({ theme }) => (theme as any).palette.grey['A400']};
`;
